// 回答種別
export const ANSWER_TYPE = {
  yes: { id: 1, name: 'はい', flag: 'あり' },
  no: { id: 0, name: 'いいえ', flag: 'なし' },
};

// 建設許可関連
export const INDUSTRY = {
  permissions: {
    // 許可
    source: {
      // 区分
      0: { id: 0, name: 'なし' },
      1: { id: 1, name: '大臣' },
      2: { id: 2, name: '知事' },
    },
    construction: {
      0: { id: 0, name: 'なし' },
      1: { id: 1, name: '一般' },
      2: { id: 2, name: '特定' },
    },
    authorized_code: {
      // 建設業許可業種一覧
      1: { id: 1, name: '土木一式工事' },
      2: { id: 2, name: '建築一式工事' },
      3: { id: 3, name: '大工工事' },
      4: { id: 4, name: '左官工事' },
      5: { id: 5, name: 'とび・土工・コンクリート工事' },
      6: { id: 6, name: '石工事' },
      7: { id: 7, name: '屋根工事' },
      8: { id: 8, name: '電気工事' },
      9: { id: 9, name: '管工事' },
      10: { id: 10, name: 'タイル・れんが・ブロック工事' },
      11: { id: 11, name: '鋼構造物工事' },
      12: { id: 12, name: '鉄筋工事' },
      13: { id: 13, name: '舗装工事' },
      14: { id: 14, name: 'しゅんせつ工事' },
      15: { id: 15, name: '板金工事' },
      16: { id: 16, name: 'ガラス工事' },
      17: { id: 17, name: '塗装工事' },
      18: { id: 18, name: '防水工事' },
      19: { id: 19, name: '内装仕上工事' },
      20: { id: 20, name: '機械器具設置工事' },
      21: { id: 21, name: '熱絶縁工事' },
      22: { id: 22, name: '電気通信工事' },
      23: { id: 23, name: '造園工事' },
      24: { id: 24, name: 'さく井工事' },
      25: { id: 25, name: '建具工事' },
      26: { id: 26, name: '水道施設工事' },
      27: { id: 27, name: '消防施設工事' },
      28: { id: 28, name: '清掃施設工事' },
      29: { id: 29, name: '解体工事' },
    },
  },
};

// 保険関連
export const INSURANCES = {
  state: {
    uninsured: { id: 0, name: '未加入' },
    insured: { id: 1, name: '加入' },
    other: { id: 2, name: '適用対象外' },
  },
  health: {
    type: {
      0: { id: 0, name: '健康保険組合' },
      1: { id: 1, name: '協会けんぽ(全国健康保険協会)' },
      2: { id: 2, name: '各種共済組合' },
      3: { id: 3, name: '国民健康保険' },
      4: { id: 4, name: '国民健康保険組合' },
      5: { id: 5, name: '後期高齢者医療制度' },
      6: { id: 6, name: '船員保険(全国健康保険協会)' },
      99: { id: 99, name: 'その他' },
    },
  },
};



// WEBPACK FOOTER //
// ./src/utilities/roanConstants.js